<template>
  <span class="render-percentage" v-bind="$attrs"> {{ format() }}% </span>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
      required: true,
    },
  },
  methods: {
    format() {
      return Math.round(this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.render-percentage {
  text-align: right;
}
</style>
